import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Box, Divider, Grid, Paper, Typography } from '@mui/material';

import { getCustomerState } from '../../../../../../features/customer/get_customer';
import { getCustomerStatus } from '../../../../../common/utils/customer_utils';
import { MISC_DATE_POLISH_FORMAT } from '../../../../../../core/constants';

const InfoField = ({ label, value }) => (
    <Box sx={ { mb: 2 } }>
        <Typography variant="caption" color="textSecondary" display="block" sx={ {
            mb: 0.5,
            textTransform: 'uppercase',
            fontWeight: 600,
            fontSize: '0.7rem',
            letterSpacing: '0.5px'
        } }>
            { label }
        </Typography>
        <Typography variant="body1" sx={ { fontWeight: 500, color: 'text.primary' } }>
            { value || '-' }
        </Typography>
    </Box>
);

const CustomerDetails = () => {
    const getCustomer = useSelector(getCustomerState);
    const data = getCustomer?.data;

    if (!data) return null;

    return (
        <Paper variant="outlined" sx={ { p: 3, backgroundColor: 'background.paper' } }>
            <Grid container spacing={ 4 }>

                <Grid item xs={ 12 } md={ 5 }>
                    <Typography variant="h6" sx={ { mb: 2, fontWeight: 600 } }>Dane profilu</Typography>
                    <InfoField label="Imię" value={ data.name }/>
                    <InfoField label="Nazwisko" value={ data.surname }/>
                    <InfoField label="Numer telefonu"
                               value={ `+${ data.phonePrefix?.prefix || '' } ${ data.phoneNumber || '' }` }/>
                    <InfoField label="Adres Email" value={ data.email }/>
                </Grid>

                <Grid item xs={ 12 } md={ 1 } sx={ { display: { xs: 'none', md: 'block' } } }>
                    <Divider orientation="vertical"/>
                </Grid>


                <Grid item xs={ 12 } md={ 6 }>
                    <Typography variant="h6" sx={ { mb: 2, fontWeight: 600 } }>System i Status</Typography>
                    <Grid container spacing={ 2 }>
                        <Grid item xs={ 6 }>
                            <InfoField label="Status konta" value={ getCustomerStatus(data.status) }/>
                        </Grid>
                        <Grid item xs={ 6 }>
                            <InfoField label="Domyślny język" value={ data.defaultLanguageCode }/>
                        </Grid>
                        <Grid item xs={ 12 }>
                            <InfoField label="Data utworzenia"
                                       value={ moment(data.createDate).format(MISC_DATE_POLISH_FORMAT) }/>
                        </Grid>
                        <Grid item xs={ 12 }>
                            <InfoField label="Ostatnia aktywność"
                                       value={ moment(data.lastActiveDate).format(MISC_DATE_POLISH_FORMAT) }/>
                        </Grid>
                    </Grid>

                    <Box sx={ { mt: 2, pt: 2, borderTop: '1px solid', borderColor: 'divider' } }>
                        <Typography variant="h6" sx={ { mb: 2, fontWeight: 600 } }>Dane firmy</Typography>
                        <Grid container spacing={ 2 }>
                            <Grid item xs={ 12 } sm={ 6 }>
                                <InfoField label="Nazwa firmy" value={ data.companyName }/>
                            </Grid>
                            <Grid item xs={ 12 } sm={ 6 }>
                                <InfoField label="NIP" value={ data.companyNip }/>
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

export default CustomerDetails;